module.exports = __webpack_public_path__ + "static/Choose-Advance.52bf43b0.svg";